import { AxiosGet, AxiosPost, AxiosDelete } from '../useApi';

export function Login(params) {
    const route = 'login';
    return AxiosGet(route, params);
}

export function CreateUser(data) {
    const route = 'users';
    return AxiosPost(route, null, data);
}

export function DeleteUser(params) {
    const route = 'users';
    return AxiosDelete(route, params);
}

export function GetUsers() {
    const route = 'users';
    return AxiosGet(route);
}

export function CreateInstanceUser(params, data) {
    const route = 'users/create-instance-user';
    return AxiosPost(route, params, data);
}

export function DeleteInstanceUser(params, data) {
    const route = 'users/delete-instance-user';
    return AxiosDelete(route, params, data);
}

export function GetUser(params) {
    const route = 'users/by-email';
    return AxiosGet(route, params);
}

export function GetInstanceUser(params) {
    const route = 'users/by-id-and-instance';
    return AxiosGet(route, params);
}

export function UpdateInstanceUser(params, data) {
    const route = 'users/update-instance-user';
    return AxiosPost(route, params, data);
}

export function UpdateUser(params, data) {
    const route = 'users/update-user';
    return AxiosPost(route, params, data);
}

export function GetUserSchedule(params) {
    const route = 'users/schedule';
    return AxiosGet(route, params);
}

export function GetUserToken() {
    const route = 'user/token';
    return AxiosGet(route);
}